import Stack from 'src/app/atoms/Layout/Stack/Stack';
import { cssVar, mediaQuery } from 'src/app/styles/helper';
import styled, { css } from 'styled-components';

interface ProductsMegaMenuContainerProps {
  isOpen: boolean;
  maxHeight: number;
}

export const ProductsMegaMenuSideContainer = styled.div<ProductsMegaMenuContainerProps>`
  position: relative;
  overflow: hidden;
  transition:
    max-height 0.3s ease-in-out,
    opacity 0.3s ease-in-out;
  max-height: ${({ isOpen, maxHeight }) => (isOpen ? maxHeight : 0)}px;
`;

export const FeaturesStack = styled(Stack)`
  flex: 1 1 53%;

  .feature-link {
    background: ${cssVar('bg-primary')};

    &:hover {
      background: ${cssVar('bg-primary-hover')};
    }
  }
`;

export const LearnMoreStack = styled(Stack)`
  flex: 1 1 47%;

  .learn-more-image {
    flex: 1 0 auto;
    max-width: 144px;

    ${mediaQuery(
      'lg',
      css`
        max-width: 100%;
      `
    )}
  }

  .learn-more-button {
    width: auto;
    padding: ${cssVar('spacing-sm')} ${cssVar('spacing-none')};
    --svg-fill: ${cssVar('text-brand-secondary')};

    &:hover {
      --svg-fill: ${cssVar('text-brand-secondary-hover')};
    }

    svg {
      transition: all 200ms ease-in-out;
    }
  }
`;
